import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { Device } from '../../misc/api/DeviceLinkApi/Devices';
import { DeviceUploadStatus } from '../DevicesNewReducer';
import { DeviceOverallUploadStatus } from './DeviceOverallUploadStatus';

export interface SuccessProps {
    explanationText: string;
    selectedInteraction: string;
    devices: Device[];
    deviceStatuses: DeviceUploadStatus[];
    handleNext: () => void;
}

export const Success = (props: SuccessProps) => {
    return (
        <div id="DeviceReturnSuccess">
            <div className="modal-header bg-primary">
                <h3 className="modal-title">Manage Device</h3>
            </div>
            <div className="modal-body">
                <p style={{ fontSize: 100 + 'px' }} className="text-center text-success">
                    <FontAwesomeIcon icon={faCheckCircle} id="SuccessStatus" aria-hidden="true" />
                </p>
                <div className="text-center">
                    {props.explanationText}
                    <DeviceOverallUploadStatus
                        devices={props.devices}
                        deviceStatus={props.deviceStatuses}
                    />
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={props.handleNext}>Finish</button>
            </div>
        </div>
    );
}
